import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import NumberFormat from "react-number-format";
import {numberWithComma, price, capacity} from "../../../utils/formatters/Numbers";

const AddInstrumentView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-9">
                        <TitlePage title={props.title}/>
                    </div>
                    <div className="p-col-3" align="right">
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnPreviousPage}/>&nbsp;
                        <Button label="Guardar"
                                onClick={props.saveInstrument}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Tipo Valor" isBold={true}/>
                        <InputText name="tipoValor" placeholder="Ex: 9999"
                                   required={true} maxLength={4}
                                   onChange={props.onChangeInputText}
                                   value={props.instrumentData.tipoValor}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <InputText name="emisora" placeholder="Ex: ALFA * 0"
                                   required={true} maxLength={15}
                                   onChange={props.onChangeInputText}
                                   value={props.instrumentData.emisora}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Serie" isBold={true}/>
                        <InputText name="serie" placeholder="Ex: 9999"
                                   required={true} maxLength={10}
                                   onChange={props.onChangeInputText}
                                   value={props.instrumentData.serie}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-1">
                        <br/>
                        <Button label="Validar"
                                onClick={props.validateEmisora}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Detalle de Emisora" isBold={true}/>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Cupón" isBold={true}/>
                        <SubtitleLabel header={props.instrumentData.cupon}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="ISIN" isBold={true}/>
                        <SubtitleLabel header={props.instrumentData.isin}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Precio" isBold={true}/>
                        <SubtitleLabel header={price(props.instrumentData.precio, "left")}/>
                    </div>
                    {props.addGuarantee &&
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Precio Descontado" isBold={true}/>
                        <SubtitleLabel header={price(props.instrumentData.precioDescontado, "left")}/>
                    </div>
                    }
                    {props.addGuarantee &&
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Cuenta" isBold={true}/>
                        <SubtitleLabel header={props.instrumentData.cuenta}/>
                    </div>
                    }
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Fecha Vencimiento" isBold={true}/>
                        <SubtitleLabel header={props.instrumentData.fechaVence}/>
                    </div>
                    {props.addGuarantee &&
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Sugerido" isBold={true}/>
                        <SubtitleLabel header={numberWithComma(props.suggested)}/>
                    </div>
                    }
                    {props.addGuarantee &&
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Aforo" isBold={true}/>
                        <SubtitleLabel header={capacity(props.instrumentData.aforoPorc, "left")}/>
                    </div>
                    }
                    {props.addGuarantee &&
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Cantidad" isBold={true}/>
                        <NumberFormat name="cantidadTitulos"
                                      thousandSeparator={true}
                                      allowNegative={false}
                                      maxLength={17}
                                      required={true}
                                      decimalScale={0}
                                      fixedDecimalScale={false}
                                      placeholder="Ex: 99,99"
                                      customInput={InputText}
                                      onChange={props.onChangeInputText}
                                      value={props.instrumentData.cantidadTitulos}
                                      tabIndex={3}/>
                    </div>
                    }
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default (AddInstrumentView);